import { useMemo } from "react";
import { TitleHeaderHyperlink } from "../../Cards/Utils/TitleHeaderHyperlink";
import { CardBase } from "../../Cards/Utils/CardHelper";
import { TaskInnerContainer } from "./TaskInnerContainer";
import { TaskProps } from "@/interfaces/tasks_types";

type TaskOuterContainerProps = {
    projectName: string,
    tasks: TaskProps[],
    isNewCard: (cardType: string, id: string) => boolean,
    markAsSeen: (cardType: string, id: string) => void,
    folderLocation: string
}
// This container is the Parent of the TaskInnerContainer. It contains the project name and the tasks inside
export function TaskOuterContainer({ projectName, tasks, isNewCard, markAsSeen, folderLocation }: TaskOuterContainerProps) {
    const hasNewTasks = useMemo(() => {
        const seenTasks = tasks.filter((task) => isNewCard('task', task.task_id ?? ''));
        return seenTasks.length > 0;
    }, []);

    return (
        <CardBase
            className="mb-2 border-b p-2 rounded-lg"
            isNew={false}
            hoverChildren={<TaskInnerContainer tasks={tasks} isNewCard={isNewCard} markAsSeen={markAsSeen} />}
            maxHeight={1000}
            hoverText="Tasks"
        >
            <TitleHeaderHyperlink title={projectName} folder_location={folderLocation} />

            <div className="text-sm text-gray-500 dark:text-stone-200">
                # of Tasks: {tasks.length}
            </div>

            {hasNewTasks && <h4 className="text-green-500 dark:text-green-400 animate-pulse">New Tasks Inside!</h4>}
        </CardBase>
    );
}
